import { Grid, Typography } from "@mui/material";
import React from "react";
import MuiInputField from "../../../../../../../Components/InputField/InputField";
import { type } from "@testing-library/user-event/dist/type";
import { TextView } from "../../../../../../../Components/TextView";
import { checkPermission } from "../../../../../../../Utils/Permissions";

function ContactPerson({
  name,
  setName,
  number,
  setNumber,
  isEditable,
  insuranceData,
}) {
  const handleOnChange = (setValue) => (event) => {
    setValue(event.target.value);
  };
  return (
    <Grid container mb={2} lg={12}>
      <Grid container lg={12}>
        <Grid item lg={3}>
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "10px",
            }}>
            Contact Person Name
          </Typography>
          {isEditable && checkPermission("KARE_DB_INSURANCE_EDIT") ? (
            <MuiInputField
              onChange={handleOnChange(setName)}
              value={name}
              placeHolder={"Add Name"}
            />
          ) : (
            <TextView>{insuranceData?.contactPersonName}</TextView>
          )}
        </Grid>
        <Grid item lg={3} marginX={"30px"}>
          <Typography
            sx={{
              fontWeight: "500",
              fontSize: "14px",
              color: "#4c5a6a",
              paddingBottom: "7px",
              paddingTop: "10px",
            }}>
            Contact Person Number
          </Typography>
          {isEditable && checkPermission("KARE_DB_INSURANCE_EDIT") ? (
            <MuiInputField
              prefix={"+91"}
              onChange={handleOnChange(setNumber)}
              value={number}
              maxlength={10}
              placeHolder={"Add Contact Number"}
            />
          ) : (
            <TextView>{"+91 " + insuranceData?.contactPersonNumber}</TextView>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default ContactPerson;
